import { render, staticRenderFns } from "./AnnualTaxServiceFeeStatementSubTable.vue?vue&type=template&id=94c034b6&"
import script from "./AnnualTaxServiceFeeStatementSubTable.vue?vue&type=script&lang=js&"
export * from "./AnnualTaxServiceFeeStatementSubTable.vue?vue&type=script&lang=js&"
import style0 from "./AnnualTaxServiceFeeStatementSubTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports